import React, { useEffect, useState } from 'react';
import {
  Table,
  Td,
  Th,
  Tr
} from '../../quoteSummary/componets/css';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json';
import { getLocale } from '../../../misc';

const CodeBasedPromotions = ({orderData,isVulcanOrder}) => {

  const locale = getLocale();

  const {
    vulcanWebform: {
      _couponCode,
      _discountAmount,
      _duration,
      _validateCode
    }
  } = locale === 'en-US' ? EN : FR;

   const {
        redeemOfferData:{redeemOfferSelection}
    } = orderData;

  const [redeemOfferData, setRedeemOfferData] = useState(redeemOfferSelection);


  return (
    <div>
      {redeemOfferData && !!redeemOfferData.length && (
        <Table>
          <Th>{isVulcanOrder ? 'Coupon Code' : _couponCode}</Th>
          <Th>{isVulcanOrder ? 'Validation Code' : _validateCode}</Th>
          <Th>{isVulcanOrder ? 'Discount Amount' : _discountAmount}</Th>
          <Th>{isVulcanOrder ? 'Duration' : _duration}</Th>
          {/* Add this column for edit/delete buttons */}
          {redeemOfferData.map(
            (
              { couponCode, validationCode, promotionAmount, duration },
              idx
            ) => (
              <Tr key={`${idx}`}>
                <Td>{couponCode}</Td>
                <Td>{validationCode}</Td>
                <Td>{promotionAmount}</Td>
                <Td>{duration}</Td>
                
              </Tr>
            )
          )}
          
        </Table>
      )}
     
    </div>
  );
};

export default CodeBasedPromotions;
